import React from "react";
import { ReactComponent as BackIcon } from "resources/icons/arrow-back-large.svg";
import { ReactComponent as ArrowsOutCardinal } from "resources/icons/ArrowsOutCardinal.svg";
import { ReactComponent as Closebutton } from "resources/icons/X.svg";

import "./NovaHistory.scss";

const NovaChatHistoryHeader = ({ onBack, onClose, setDisabled }) => {
  return (
    <div className="flex align-center justify-between">
      <div className="flex align-center">
        <BackIcon
          className="cursor-pointer mr-10 history-back-icon"
          onClick={onBack}
        />
        <div className="fs-regular fw-600 color-grey">History</div>
      </div>

      <div className="flex align-end chat-with-nova-ai-header-options">
        <ArrowsOutCardinal
          className="draggable-handle cursor-move"
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        />
        <Closebutton
          className="cursor-pointer ai-modal-close-svg"
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default NovaChatHistoryHeader;
